import { motion } from "framer-motion";
import { GALLERY } from "../../data";
import { Reveal } from "./Reveal";

export default function Gallery() {
  return (
    <section id="trabalhos" className="relative bg-white py-24 md:py-36" data-testid="gallery">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <Reveal>
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-royal font-semibold mb-5">Trabalhos reais</p>
            <h2 className="font-display font-extrabold text-ink tracking-tight text-4xl md:text-6xl leading-[1.02]">
              O antes e o<br />depois da luz.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-muted-foreground md:text-lg max-w-sm">
              Fotografias e vídeos dos nossos serviços — capturados no terreno, dia após dia.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 [grid-auto-rows:220px] md:[grid-auto-rows:300px]">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.06 }}
              className={`group relative overflow-hidden rounded-2xl ${g.tall ? "row-span-2" : ""} ${i === 0 ? "col-span-2 lg:col-span-1" : ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img src={g.src} alt={g.label} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-4 left-4 right-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-display font-semibold text-white text-sm md:text-base">{g.label}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
